module.exports = __webpack_public_path__ + "static/media/black-grey-surrealism-girl-and-skull-tattoo.a34b9056.webm";